import { useEffect, useState } from 'react';

const useElapsedTime = (isPunchedIn) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (!isPunchedIn) {
      localStorage.removeItem("punchInTime");
      setElapsedTime(0);
      return;
    }

    // Set punchInTime if not present (only once at punch-in)
    let punchInTime = localStorage.getItem("punchInTime");
    if (!punchInTime) {
      punchInTime = Date.now();
      localStorage.setItem("punchInTime", punchInTime);
    }

    const updateElapsedTime = () => {
      const now = Date.now();
      const diff = now - parseInt(punchInTime, 10);
      setElapsedTime(Math.floor(diff / 1000));
    };

    updateElapsedTime(); // Run immediately
    const interval = setInterval(updateElapsedTime, 1000);

    return () => clearInterval(interval);
  }, [isPunchedIn]);

  return formatTime(elapsedTime);
};

const formatTime = (totalSeconds) => {
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export default useElapsedTime;
